import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';
import { LegacyUploadService } from '@shared/services/legacy-upload.service'; 
import { StockEquipmentsService } from '@app/shared/services/entities/stockEquipments.service';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('INTERVENTION UPLOAD DOWNLOAD FORM COMPONENT')

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
    selector: 'app-documents-upload-download-form',
    templateUrl: './documents-upload-download-form.component.html',
    styleUrls: ['./documents-upload-download-form.component.scss'],
})
export class DocumentsUploadDownloadFormComponent implements OnInit {
    errorMessageTime = 4000;
    successMessageTime = 2000;

    uiLoading: boolean = true;

    date: string = '';
    files = [];

    data: any = {};
    record: any = {};
    newData: any = {};

    fileName = [];
    urls = [];
    
    // Nuevas propiedades para PDFs
    pdfUrls: SafeResourceUrl[] = [];
    hasPdfFiles: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<DocumentsUploadDownloadFormComponent>,
        private customMessage: CustomMessageService,
        private http: HttpClient,
        private uploadImage: LegacyUploadService,
        private inventoryEquipmentsService: StockEquipmentsService,
        private sanitizer: DomSanitizer, // ⭐ Agregar DomSanitizer
        @Inject(MAT_DIALOG_DATA) public injectedData: any,
    ) {
        this.data = JSON.parse(JSON.stringify(injectedData));
        log.debug('[_constructor] data:', this.data);
    }

    ngOnInit() {
        this.uiLoading = false;
        this.record = this.data.record;
        this.newData = this.data.data;
        if(this.data.type === 'download') this.downloadFiles();
    }

    /** Agrega las imagenes a la interfaz para poderlas previsualizar. */
    onFileSelected(event) {
        if (event.target.files) {
            (document.getElementById('save_button') as HTMLInputElement).disabled = false;
            (document.getElementById('save_button') as HTMLInputElement).style.cursor = 'pointer';
            let newFiles = Array.from(event.target.files);
            
            for (let i = 0; i < newFiles.length; i++) {
                const fileType = event.target.files[i].type.split("/")[0];
                const fullType = event.target.files[i].type;
                
                if (fileType === "image" || fileType === "application") {
                    this.files.push(newFiles[i]);
                    this.fileName.push(event.target.files[i].name);
                    
                    var reader = new FileReader();
                    reader.readAsDataURL(event.target.files[i]);
                    reader.onload = (events: any) => {
                        const result = events.target.result;
                        this.urls.push(result);
                        
                        // Si es PDF, sanitizar la URL
                        if (fullType === 'application/pdf') {
                            const sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(result);
                            this.pdfUrls.push(sanitizedUrl);
                        }
                    }
                }
            }
            log.debug('Files', this.files);
        }
    }

    /** Elimina la imagen cargada */
    _removeImage(index: number) {
        this.files.splice(index, 1);
        this.urls.splice(index, 1);
        this.fileName.splice(index, 1);
        this.pdfUrls.splice(index, 1); // También eliminar de pdfUrls
        
        if (this.files.length === 0) {
            (document.getElementById('save_button') as HTMLInputElement).disabled = true;
            (document.getElementById('save_button') as HTMLInputElement).style.cursor = 'no-drop';
        }
    }

async downloadFiles() {
    try {
        this.uiLoading = true;
        this.customMessage.open({ 
            title: "Espere",
            type: 'success', 
            message: 'Descargando archivos.', 
            duration: 2000, 
            loading: true 
        });
        
        let formData = new FormData();
        let folio = `${this.record['id']}-${this.newData['contractName']}-${this.newData['fileNumber']}`;
        
        formData.append('folio', folio);
        formData.append('type', 'download');
        formData.append('service', '');
        formData.append('path', 'equipments');
        
        log.debug('[downloadFiles] Folio:', folio);
        
        let apiResponse = await this.uploadImage.upload(formData);
        
        log.debug('[downloadFiles] API Response:', apiResponse);

        if (!apiResponse || apiResponse.state !== 'success') {
            throw new Error(apiResponse?.message || 'Error al descargar archivos');
        }

        // ⭐ La estructura ahora es { state, message, data: [...], count }
        const urls = apiResponse.data || [];

        if (!Array.isArray(urls) || urls.length === 0) {
            this.customMessage.close();
            this.uiLoading = false;
            await this.customMessage.open({
                title: 'Información', 
                message: 'No hay archivos disponibles para este mantenimiento', 
                type: 'warning', 
                duration: 2000
            });
            return;
        }

        this.urls = [];
        this.pdfUrls = [];
        this.fileName = [];

        urls.forEach((url: string, index: number) => {
            if (!url || typeof url !== 'string' || !url.startsWith('data:')) {
                log.warn(`[downloadFiles] URL ${index} no válida`);
                return;
            }
            
            this.urls.push(url);
            this.fileName.push(`Documento_${index + 1}.pdf`);
            
            if (url.includes('application/pdf')) {
                const sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                this.pdfUrls.push(sanitizedUrl);
            } else {
                this.pdfUrls.push(null);
            }
        });

        this.customMessage.close();
        this.uiLoading = false;
        
        if (this.urls.length > 0) {
            this.customMessage.open({
                title: "Espere",
                type: 'success',
                message: `${this.urls.length} archivo(s) cargado(s)`,
                duration: 2000
            });
        }

    } catch (error) {
        this.customMessage.close();
        this.uiLoading = false;
        log.error('[downloadFiles] Error:', error);
        
        await this.customMessage.open({
            title: 'Error', 
            message: error.message || 'Error al descargar archivos', 
            type: 'error', 
            duration: 3000
        });
    }
}
    /** Cierra el modal */
    _close() {
        this.dialogRef.close();
    }

    /** Manda las imágenes al API */
    async _save() {
        try {
            const formData = new FormData();
            let folio = `${this.record['id']}-${this.newData['contractName']}-${this.newData['fileNumber']}`;
            
            formData.append('folio', folio);
            formData.append('type', 'upload');
            formData.append('path', 'equipments');
            
            for (var i = 0; i < this.files.length; i++) {
                let extension = this.files[i].type.split("/")[1];
                formData.append("doc", this.files[i], `doc.${extension}`);
            }
            
            await this.uploadImage.upload(formData);
            this.customMessage.open({ 
                title: "Espere",
                type: 'success', 
                message: 'Archivos guardados exitosamente.', 
                duration: 2000, 
                loading: true 
            });
            
            setTimeout(() => {
                this.dialogRef.close({ pdf: true });
            }, 1000);
            
        } catch (error) {
            this.customMessage.close();
            this.customMessage.open({ 
                title: "Espere",
                type: 'error', 
                message: error.message || 'Error al guardar archivos', 
                duration: 2000 
            });
            this.dialogRef.close({ pdf: false });
        }
    }

    // Método helper para verificar si es PDF
    isPdf(url: string, index: number): boolean {
        return this.pdfUrls[index] !== null && this.pdfUrls[index] !== undefined;
    }

    // Método para descargar archivo individual
    downloadFile(url: string, fileName: string) {
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
    }
}